const BarChart = props => {
  const { categories, series, theme, options } = props;

  return {
    credits: {
      enabled: false
    },
    chart: {
      type: 'column',
      style: {
        fontFamily: theme.typography.fontFamily
      }
    },
    title: {
      text: ''
    },
    legend: {
      enabled: false
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        maxPointWidth: 40,
        cursor: 'pointer'
      }
    },
    tooltip: {
      useHTML: true,
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      formatter: function () {
        return `<table style='background-color:${
          this.series.color
        };padding: 5px; border-radius: 2px'><tr><td style="text-align: center;"><b>${this.y.toLocaleString()}</b></td></tr><tr><td style="text-align: center;">${
          this.series.name
        }</td></tr></table>`;
      },
      style: theme.typography.tooltip
    },
    xAxis: {
      type: 'datetime',
      categories: categories,
      title: {
        text: options.xAxisTitle,
        style: theme.typography.h6,
        margin: 16
      },
      tickLength: 0,
      labels: {
        enabled: true,
        style: theme.typography.h6,
        rotation: -45
      }
    },
    yAxis: {
      minTickInterval: 1,
      labels: {
        format: '{value:,.0f}',
        style: theme.typography.h6
      },
      title: {
        text: options.yAxisTitle,
        style: theme.typography.h6,
        x: -16,
        margin: 16
      }
    },
    series: series
  };
};

export { BarChart };
